import { IElementViewDigest } from './model';
import { OwnerByEnum } from '../../services/eleview/types/model';

export class ElementViewDigest implements IElementViewDigest {
	OwnerBy: OwnerByEnum;
	Owner: string;
	Name: string;
	static fromInterface(data: IElementViewDigest) {
		const rev = new ElementViewDigest();
		Object.assign(rev, data);
		return rev;
	}
	displayLabel(): string {
		if (this.OwnerBy === OwnerByEnum.ownerByEle) {
			return 'ç¼ºçæ¾ç¤ºå';
		}
		if (this.OwnerBy === OwnerByEnum.unknow) {
			return 'æ ç­¾åå¹¶å';
		}
		return this.Name;
	}
	canModify(userName: string, deptCode: string): boolean {
		return (
			(this.OwnerBy === OwnerByEnum.ownerByDept && this.Owner === deptCode) ||
			(this.OwnerBy === OwnerByEnum.ownerByUser && this.Owner === userName)
		);
	}
}
